import gql from 'graphql-tag';
import { CART_FRAGMENT, COMPLETED_PAYMENT_INFO_FRAGMENT } from '../fragments';

export const WPS_DONE_PAGE_QUERY = gql`
  query WPSDonePageQuery($token: String!) {
    checkoutSession(token: $token) {
      merchant {
        name
        preferences {
          autoReturnToMerchant
          enablePaymentDataTransfer
          returnUrl
        }
      }
      buyer {
        userId
        email {
          stringValue
        }
        name {
          fullName
        }
      }
      fundingOptions {
        fundingInstrument {
          lastDigits
          name
          nameDescription
          type
        }
      }
      shippingAddresses {
        fullAddress
        name {
          fullName
        }
      }
      ...CartDonePage
      ...CompletedPaymentInfo
    }
  }
  ${CART_FRAGMENT}
  ${COMPLETED_PAYMENT_INFO_FRAGMENT}
`;
